import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectUserDepartmentId } from '../../../store/selectors/auth';
import { TCollectiveTemplateItem } from '../../../types/templates';
import { sortByDepId } from '../../../utils/templates';

interface IUseTemplateListLogicReturn {
  sortedTemplates: TCollectiveTemplateItem[];
  isEmpty: boolean;
}

export const useTemplateListLogic = (templates: TCollectiveTemplateItem[]): IUseTemplateListLogicReturn => {
  const userDepartmentId = useSelector(selectUserDepartmentId);

  const sortedTemplates = useMemo(
    () => [...templates].sort(sortByDepId(userDepartmentId)),
    [templates, userDepartmentId],
  );

  const isEmpty = !sortedTemplates || sortedTemplates.length === 0;

  return {
    sortedTemplates,
    isEmpty,
  };
};
